import { cloneDeep } from "lodash";
import { supabase } from "../supabaseClient";

async function getAllLaunchesByEvent(eventId) {
  let query = supabase
    .from("Launches")
    .select("*,projectId(*)")
    .eq("eventId", eventId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function getAllLaunchesByEventForSettings(eventId) {
  let query = supabase.rpc("getuniqueunittypesforcolorselection", {
    pid: eventId,
  });
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function getLaunchById(launchId) {
  let query = supabase
    .from("Launches")
    .select("*,projectId(*)")
    .eq("launchId", launchId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function addLaunch(launch) {
  launch.created_at = Date.now();
  const { data, error } = await supabase.from("Launches").insert(launch);
  if (data) return data;
  else throw error;
}

async function editLaunch(obj, launchId) {
  console.log(obj);
  obj.last_updated_at = Date.now();
  const { data, error } = await supabase
    .from("Launches")
    .update(obj)
    .eq("launchId", launchId);
  if (data) return data;
  else throw error;
}

async function getLaunchByTitle(title, eventId) {
  const { data, error } = await supabase
    .from("Launches")
    .select("*")
    .ilike("title", `%${title}%`)
    .eq("eventId", eventId);
  if (data) return data;
  else throw error;
}

async function getAllCpByLaunch(launchId) {
  let query = supabase
    .from("LaunchCpRelations")
    .select("*")
    .eq("launchId", launchId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function getAllSalesByLaunch(launchId) {
  let query = supabase
    .from("LaunchSalesRelations")
    .select("*")
    .eq("launchId", launchId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function getAllSalesByProject(projectId) {
  let query = supabase
    .from("SustenanceSalesRelations")
    .select("*")
    .eq("projectId", projectId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}
async function getAllSalesByProjectWings(projectId, wingId) {
  let query = supabase
    .from("SustenanceWingsSalesRelations")
    .select("*")
    .eq("projectId", projectId)
    .eq("wingId", wingId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}
async function getAllSalesByProjectFloors(projectId, wingId, floorNo) {
  let query = supabase
    .from("SustenanceFloorsSalesRelations")
    .select("*")
    .ilike("floorNo", `%${floorNo}%`)
    .eq("projectId", projectId)
    .eq("wingId", wingId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}
async function insertIntoSalesRelations(obj) {
  obj.created_at = Date.now();
  let query = supabase.from("LaunchSalesRelations").insert(obj);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function deleteSalesRelations(obj, launchId) {
  let query = supabase
    .from("LaunchSalesRelations")
    .delete()
    .eq("launchId", launchId)
    .eq("userId", obj.userId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function insertIntoCpRelations(obj) {
  obj.created_at = Date.now();
  let query = supabase.from("LaunchCpRelations").insert(obj);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function deleteCpRelations(obj, launchId) {
  let query = supabase
    .from("LaunchCpRelations")
    .delete()
    .eq("launchId", launchId)
    .eq("cpId", obj.cpId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}
async function insertIntoPriceListRelations(obj) {
  obj.created_at = Date.now();
  let query = supabase.from("LaunchPricingRelations ").insert(obj);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function deletePriceListRelations(obj, launchId) {
  let query = supabase
    .from("LaunchPricingRelations ")
    .delete()
    .eq("launchId", launchId)
    .eq("projectPricingId", obj.projectPricingId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function insertIntoPaymentRelations(obj) {
  obj.created_at = Date.now();
  let query = supabase.from("LaunchPaymentPlanRelations").insert(obj);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function deletePaymentRelations(obj, launchId) {
  let query = supabase
    .from("LaunchPaymentPlanRelations")
    .delete()
    .eq("launchId", launchId)
    .eq("paymentPlanId", obj.paymentPlanId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function updateLaunch(id, obj) {
  let newobj = cloneDeep(obj);
  newobj.last_updated_at = Date.now();
  const { data, error } = await supabase
    .from("Launches")
    .update(newobj)
    .eq("launchId", id);
  if (data) return data;
  else throw error;
}

const getLaunchTokenById = async (launchId) => {
  let query = supabase
    .from("PreselectInventoryRelations")
    .select("*,eventTokenId(*,tokenId(*)))")
    .eq("launchId", launchId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
};

const getTokenPreselectInfoById = async (eventId, eventTokenId, launchId) => {
  let query = supabase
    .from("PreselectConfirmationConfig")
    .select("*")
    .eq("eventId", eventId)
    .eq("eventTokenId", eventTokenId)
    .eq("launchId", launchId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
};

async function insertIntoPreselectConfirmationConfig(obj) {
  let query = supabase.from("PreselectConfirmationConfig").insert(obj);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}
async function updateIntoPreselectConfirmationConfig(obj) {
  const { data, error } = await supabase
    .from("PreselectConfirmationConfig")
    .update(obj)
    .eq("launchId", obj.launchId)
    .eq("eventId", obj.eventId)
    .eq("eventTokenId", obj.eventTokenId);
  if (data) return data;
  else throw error;
}

//online booking config
const getTokenOnlineInfoById = async (eventId, eventTokenId, launchId) => {
  let query = supabase
    .from("EventOnlineBookingConfig")
    .select("*")
    .eq("Event_id", eventId)
    .eq("Token_id", eventTokenId)
    .eq("Launch_id", launchId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
};

// ✅ Check if record exists, then update or insert accordingly
async function saveOrUpdateOnlineBookingConfig(obj) {
  try {
    console.log("Incoming object:", obj);

    // 1️⃣ Check if the record already exists
    const { data: existing, error: fetchError } = await supabase
      .from("EventOnlineBookingConfig")
      .select("id")
      .eq("Launch_id", obj.Launch_id)
      .eq("Event_id", obj.Event_id)
      .eq("Token_id", obj.Token_id)
      .maybeSingle(); // Returns null if not found

    if (fetchError) {
      console.error("❌ Error checking existing record:", fetchError);
      throw fetchError;
    }

    // ✅ Safe conversion helper
    const toMillisSafe = (value) => {
      if (!value) return null;
      if (typeof value === "number") return value;
      if (typeof value === "string" && !isNaN(Number(value))) return Number(value);
      const date = new Date(value);
      return isNaN(date.getTime()) ? null : date.getTime();
    };

    const startMillis = toMillisSafe(obj.Startdate);
    const endMillis = toMillisSafe(obj.Enddate);

    // 2️⃣ If record exists → UPDATE
    if (existing) {
      console.log("📝 Record exists → updating...");

      const { data, error } = await supabase
        .from("EventOnlineBookingConfig")
        .update({
          startDate: startMillis,
          endDate: endMillis,
          isOnlineBookingAccept: obj.Isonlinebookingaccept,
          allowAutoCancellation: obj.allowAutoCancellation || false,
        })
        .eq("Launch_id", obj.Launch_id)
        .eq("Event_id", obj.Event_id)
        .eq("Token_id", obj.Token_id)
        .select();

      if (error) throw error;

      console.log("✅ Successfully updated booking config.");
      return { success: true, message: "Configuration updated.", data };
    }

    // 3️⃣ If not found → INSERT
    console.log("➕ No existing record → inserting new...");

    const { data: insertData, error: insertError } = await supabase
      .from("EventOnlineBookingConfig")
      .insert({
        Launch_id: obj.Launch_id,
        Event_id: obj.Event_id,
        Token_id: obj.Token_id,
        startDate: startMillis,
        endDate: endMillis,
        isOnlineBookingAccept: obj.Isonlinebookingaccept,
        allowAutoCancellation: obj.allowAutoCancellation || false,
      })
      .select();

    if (insertError) throw insertError;

    console.log("✅ Successfully inserted booking config.");
    return { success: true, message: "Configuration inserted.", data: insertData };

  } catch (err) {
    console.error("❌ saveOrUpdateOnlineBookingConfig failed:", err.message);
    return { success: false, message: err.message };
  }
}


export {
  updateIntoPreselectConfirmationConfig,
  insertIntoPreselectConfirmationConfig,
  getTokenPreselectInfoById,
  getLaunchTokenById,
  getLaunchByTitle,
  getAllLaunchesByEvent,
  addLaunch,
  editLaunch,
  insertIntoPaymentRelations,
  deletePaymentRelations,
  getLaunchById,
  getAllCpByLaunch,
  getAllSalesByLaunch,
  getAllLaunchesByEventForSettings,
  insertIntoSalesRelations,
  deleteSalesRelations,
  insertIntoCpRelations,
  deleteCpRelations,
  insertIntoPriceListRelations,
  deletePriceListRelations,
  getAllSalesByProject,
  updateLaunch,
  getAllSalesByProjectWings,
  getAllSalesByProjectFloors,
  getTokenOnlineInfoById,
  saveOrUpdateOnlineBookingConfig
  // insertIntoOnlineBookingConfig,
  // updateIntoOnlineBookingConfig,
};
